<template>
  <div class="subpage sign" ref="signRef">
    <Header v-if="$route.query.platform !== 'mini'" :title="title" :is-sub-page="true" ref="navBarRef"></Header>

    <div class="content" ref="contentRef">
      <cube-form :model="formData">
        <cube-form-group>
          <cube-form-item v-for="(field, index) in fields" :key="index" :field="field"></cube-form-item>
        </cube-form-group>

        <cube-form-group class="submit">
          <cube-button @click="doSign">立即报名</cube-button>
        </cube-form-group>

      </cube-form>
    </div>
  </div>
</template>

<script>
import Header from '../../../components/Header'
import { signCourse } from '@/api/course'

export default {
  name: 'Sign',
  components: {
    Header
  },
  data () {
    return {
      title: '课程报名',
      formData: {
        name: '',
        phone: '',
        company: '',
        referrer: '',
        address: '',
        note: ''
      },
      fields: [
        {
          type: 'input',
          modelKey: 'name',
          label: '姓名',
          props: {
            placeholder: '请输入姓名'
          },
          rules: {
            required: true
          }
        },
        {
          type: 'input',
          modelKey: 'phone',
          label: '手机',
          props: {
            placeholder: '请输入手机号码'
          },
          rules: {
            required: true
          }
        },
        {
          type: 'input',
          modelKey: 'company',
          label: '单位',
          props: {
            placeholder: '请输入单位名称'
          }
        },
        {
          type: 'input',
          modelKey: 'referrer',
          label: '推荐人',
          props: {
            placeholder: '请输入推荐人'
          }
        },
        {
          type: 'textarea',
          modelKey: 'address',
          label: '地址',
          props: {
            placeholder: '请输入地址'
          }
        },
        {
          type: 'textarea',
          modelKey: 'note',
          label: '备注',
          props: {
            placeholder: '请输入备注信息',
            maxlength: 100
          }
        }
      ]
    }
  },
  mounted () {
    console.log(this.$route.query)

    document.title = '课程报名'
    if (this.$route.query && this.$route.query.token) {
      this.$store.commit('setInfo', { token: this.$route.query.token })
    }

    this.$nextTick(() => {
      const navBarHeight = this.$refs.navBarRef ? this.$refs.navBarRef.$el.clientHeight : 0
      this.$refs.contentRef.style.height = (this.$refs.signRef.clientHeight - navBarHeight) + 'px'
    })
  },
  methods: {
    doSign () {
      const json = {
        notifyId: this.$route.query.id,
        name: this.formData.name,
        phone: this.formData.phone
      }

      if (this.formData.company.length !== 0) {
        json['company'] = this.formData.company
      }
      if (this.formData.referrer.length !== 0) {
        json['referrer'] = this.formData.referrer
      }
      if (this.formData.address.length !== 0) {
        json['address'] = this.formData.address
      }
      if (this.formData.note.length !== 0) {
        json['remarks'] = this.formData.note
      }

      signCourse(json).then((res) => {
        console.log('signCourse res=' + res.code + '  msg=' + res.msg)

        this.$createToast({
          txt: '报名成功',
          type: 'txt'
        }).show()
      })
    },
    doTest () {
      console.log('just test')
    }
  }
}
</script>

<style lang="stylus">
body
  background-color #f7f7f7 !important
.sign
  height 100%
  .cube-form
    height 100%
    position relative
    background transparent
    padding-top 5px
    box-sizing border-box
    .cube-form-group
      background-color #fff
    .cube-form-label
      width 80px
    .cube-form-item
      padding 0 20px
    .submit
      position absolute
      bottom 0
      left 0
      right 0
    .cube-btn
      border-radius 0
      background-color #662C85
    .cube-form-item_required .cube-form-label::after
      content "*"
      display block
      margin-top 0.026667rem
      margin-left 0.3em
      color #e64340
    .cube-form-item_required .cube-form-label::before
      content ""
      margin 0
    .border-bottom-1px::after
      border-color #E9E9E9
</style>
